// extracted by mini-css-extract-plugin
export default {"followIcon":"_1qCaR","activeIcon":"jvfVu","inActiveIcon":"UXKwD","followBackgroundClass":"_1GWl2"};